import React from "react";
import {
  FaImage,
  FaGamepad,
  FaFileContract,
  FaChartLine,
} from "react-icons/fa";

function NFTIntegration() {
  return (
    <>
      <div className="services-style-two-area default-padding">
        <div className="shape">
          <img
            src="assets/img/thumb/ai_optimized_img.png"
            alt="Image Not Found"
          />
        </div>

        <div className="container">
          <div className="row">
            <div className="col-xl-8 offset-xl-4 col-lg-8">
              <div className="site-heading">
                <h4 className="sub-title">Our Services</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Key Features of Our Crypto Gaming Solutions
                </h2>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-xl-8 offset-xl-4">
              <div className="services-style-four-items">
                {/* NFT Integration */}
                <div className="services-style-four-item">
                  <div className="icon">
                    <FaImage size={38} />
                  </div>
                  <h4>NFT Integration</h4>
                  <p>
                    Create in-game assets as NFTs that players can own, earn or
                    trade in secondary markets.
                  </p>
                </div>

                {/* Play to Earn */}
                <div className="services-style-four-item">
                  <div className="icon">
                    <FaGamepad size={38} />
                  </div>
                  <h4>Play-to-Earn Models</h4>
                  <p>
                    Reward systems that let players earn cryptocurrency,
                    increasing game engagement and retention.
                  </p>
                </div>

                {/* Smart Contracts */}
                <div className="services-style-four-item">
                  <div className="icon">
                    <FaFileContract size={38} />
                  </div>
                  <h4>Smart Contracts & Blockchain</h4>
                  <p>
                    Ensuring seamless, secure transactions and asset management
                    with smart contracts on blockchain networks.
                  </p>
                </div>

                {/* DeFi */}
                <div className="services-style-four-item">
                  <div className="icon">
                    <FaChartLine size={38} />
                  </div>
                  <h4>DeFi Integration</h4>
                  <p>
                    DeFi features like staking, yield farming, and liquidity
                    mining for a richer gaming experience.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NFTIntegration;
